import { FC } from 'react';
import ReactModal from 'react-modal';
import { theme } from 'styles/theme';
import { PropsChildren } from '../../../../@types/modals.types';

const customStyles = {
  overlay: {
    zIndex: 5,
    backgroundColor: 'rgba(23, 26, 29, 0.75)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    position: 'relative' as const,
    inset: 'auto',
    border: 'none',
    borderRadius: theme.radii.card,
    padding: 0,
    background: theme.brand.surface,
    maxWidth: '92vw',
    maxHeight: '90vh',
    overflow: 'auto',
  },
};

ReactModal.setAppElement('#modal-root');

type Props = {
  isModalOpen: boolean,
  handleCloseModal: () => void,
};

export const ModalYellowGradient: FC<PropsChildren & Props> = ({
  children,
  isModalOpen,
  handleCloseModal,
}) => {
  return (
    <>
      <ReactModal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        style={customStyles}
      >
        {children}
      </ReactModal>
    </>
  );
};
